import React from 'react'
import DocumentsList from '../../../DocumentsList';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState,
} from "react-accessible-accordion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faEllipsisVertical, faFileLines, faList, faStickyNote, faUser } from '@fortawesome/free-solid-svg-icons';
import { ContactActivity } from '../../../../../CommonComponents/ContactActivity';
import { UnauthViewModal } from '../../../../../CommonComponents/UnauthViewModal';
import { FaStickyNote } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import useLocalStorageState from 'use-local-storage-state';
import { CompanyContactAccordion } from './CompanyContactAccordion';
import { CompanyNotes } from './CompanyNotes';
import { Col } from 'react-bootstrap';
import { useGetEssentials } from '../../../../../Utils/hooks/useGetEssentials';

export const RightSideCompanyDetails = ({ companyId, companyData }) => {

    // Session storage and authentication setup
    const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()

    // rbac permission object
    const [PERMISSION] = useLocalStorageState('permission');

    const companyDocGrant = PERMISSION?.company?.feature?.document;
    return (
        <Col
            md={4}
            style={{ height: "96%", borderLeft: "1px solid #d1d4e3" }}
            className="pt-0"
        >
            <div className="card h-100 cardBorders">
                <Accordion
                    allowZeroExpanded
                    preExpanded={["activities"]}
                    style={{
                        overflow: "auto",
                        paddingBottom: 9,
                        height: "99.4%",
                    }}
                >
                    {/* Contacts (Always Open Initially) */}
                    <AccordionItem
                        uuid="contacts"
                        style={styles.accordion__item}
                    >
                        <AccordionItemHeading style={styles.accordion__heading}>
                            <AccordionItemState>
                                {({ expanded }) => (
                                    <AccordionItemButton
                                        className="accordion__button"
                                        style={styles.accordion__button}
                                    >
                                        <h5
                                            className="accordion__title"
                                            style={styles.accordion__title}
                                        >
                                            <FontAwesomeIcon
                                                icon={faUser}
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#536485",
                                                    width: "16px",
                                                }}
                                            />
                                            Contacts
                                        </h5>
                                        <FontAwesomeIcon
                                            icon={expanded ? faAngleUp : faAngleDown}
                                            style={{ transition: "transform 0.3s ease" }}
                                        />
                                    </AccordionItemButton>
                                )}
                            </AccordionItemState>
                        </AccordionItemHeading>
                        <AccordionItemPanel
                            className="accordion__panel"
                            style={styles.accordion__panel}
                        >
                            <CompanyContactAccordion
                                companyData={companyData}
                            />
                        </AccordionItemPanel>
                    </AccordionItem>

                    {/* Notes */}

                    <AccordionItem
                        uuid="notes"
                        style={styles.accordion__item}
                    >
                        <AccordionItemHeading style={styles.accordion__heading}>
                            <AccordionItemState>
                                {({ expanded }) => (
                                    <AccordionItemButton
                                        className="accordion__button"
                                        style={styles.accordion__button}
                                    >
                                        <h5
                                            className="accordion__title"
                                            style={styles.accordion__title}
                                        >
                                            <FontAwesomeIcon
                                                icon={faStickyNote}
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#536485",
                                                    width: "16px",
                                                }}
                                            />
                                            Notes
                                        </h5>
                                        <FontAwesomeIcon
                                            icon={expanded ? faAngleUp : faAngleDown}
                                            style={{ transition: "transform 0.3s ease" }}
                                        />
                                    </AccordionItemButton>
                                )}
                            </AccordionItemState>
                        </AccordionItemHeading>

                        <AccordionItemPanel
                            className="accordion__panel"
                            style={styles.accordion__panel}
                        >
                            <CompanyNotes companyId={companyId} />
                        </AccordionItemPanel>
                    </AccordionItem>

                    {/* Quotations */}
                    <AccordionItem
                        uuid="quotations"
                        style={styles.accordion__item}
                    >
                        <AccordionItemHeading style={styles.accordion__heading}>
                            <AccordionItemState>
                                {({ expanded }) => (
                                    <AccordionItemButton
                                        className="accordion__button"
                                        style={styles.accordion__button}
                                    >
                                        <h5
                                            className="accordion__title"
                                            style={styles.accordion__title}
                                        >
                                            <FontAwesomeIcon
                                                icon={faFileLines}
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#536485",
                                                    width: "16px",
                                                }}
                                            />
                                            Documents
                                        </h5>
                                        <FontAwesomeIcon
                                            icon={expanded ? faAngleUp : faAngleDown}
                                            style={{ transition: "transform 0.3s ease" }}
                                        />
                                    </AccordionItemButton>
                                )}
                            </AccordionItemState>
                        </AccordionItemHeading>
                        <AccordionItemPanel
                            className="accordion__panel"
                            style={styles.accordion__panel}
                        >
                            <div
                                className="listStyleForContact"
                                style={{
                                    minHeight: "33rem",
                                    height: "23rem",
                                    overflowX: "auto",
                                }}
                            >
                                <DocumentsList
                                    id={companyId}
                                    moduleType="Company"
                                    docGrant={companyDocGrant}
                                />
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                    {/* Activities */}
                    <AccordionItem
                        uuid="activities"
                    // style={styles.accordion__item}
                    >
                        <AccordionItemHeading style={styles.accordion__heading}>
                            <AccordionItemState>
                                {({ expanded }) => (
                                    <AccordionItemButton
                                        className="accordion__button"
                                        style={styles.accordion__button}
                                    >
                                        <h5
                                            className="accordion__title"
                                            style={styles.accordion__title}
                                        >
                                            <FontAwesomeIcon
                                                icon={faList}
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#536485",
                                                    width: "16px",
                                                }}
                                            />
                                            Activities
                                        </h5>
                                        <FontAwesomeIcon
                                            icon={expanded ? faAngleUp : faAngleDown}
                                            style={{ transition: "transform 0.3s ease" }}
                                        />
                                    </AccordionItemButton>
                                )}
                            </AccordionItemState>
                        </AccordionItemHeading>
                        <AccordionItemPanel
                            className="accordion__panel"
                            style={styles.accordion__panel}
                        >
                            <ContactActivity module_id={companyId} module_name={"company"} headers={headers} extras={extras} />
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div>
        </Col>
    )
}

const styles = {
    buttons: {
        color: "#fff",
        fontSize: "13px",
        height: "27px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "-16px",
    },
    accordion__item: {
        borderRadius: "0px",
        borderBottom: " 1px solid #d7d7d7",
        animation: "cardEntry 1s ease-out forwards",
    },
    accordion__heading: {
        width: "100%",
    },
    accordion__panel: {
        padding: "14px 0px ",
        maxHeight: "35rem",
        overflow: "auto",
        minHeight: "35rem",
        animation: "cardEntry 1s ease-out forwards",
    },
    accordion__button: {
        display: "flex",
        alignItems: "center",
        padding: "13px 20px",
        justifyContent: "space-between",
        background: "#f4f4f4",
    },
    accordion__title: {
        marginBottom: 0,
        fontWeight: 300,
        letterSpacing: "0.0119rem",
        fontSize: "1rem",
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        gap: "5px",
    },
    contactDetails: {
        display: "flex",
        alignItems: "center",
        gap: "13px",
        padding: "14px 16px ",
        borderBottom: "0.01rem solid #ebebeb",
    },
    roundedIcons: {
        width: "45px",
        height: "45px",
        backgroundColor: "#d5d6e8",
        color: "#2e384d",
    },
    departmentName: {
        color: "#3f97fd",
        fontSize: "13px",
        fontWeight: 400,
        marginLeft: "9px",
        marginBottom: 0,
    },
    departmentEmails: {
        color: "grey",
        fontWeight: 300,
    },
};